module.exports = __webpack_public_path__ + "images/home/product/third-party-06b1f0d34058d7f345f9af7aecead6c7.png";